import { selectCurrentEntitiesById } from 'ducks/entities/selectors'
import { createBasicSelector } from 'util/redux'

export const selectAttachmentsById = createBasicSelector(state =>
  selectCurrentEntitiesById(state, 'attachment')
)
